import { ADMIN_SET_AUTH, ADMIN_LOG_OUT } from "./mutation-types";

const { userName, token, type, userMode } = JSON.parse(
  localStorage.getItem("admin")
) || {
  userName: null,
  token: null,
  type: null,
  userMode: null
};

export default {
  state: {
    userName: userName,
    token: token,
    type: type,
    userMode: userMode,
  },
  getters: {
    isAdminLogin(state, getters, rootState) {
      if (state.userName && state.token) {
        return true;
      } else {
        return false;
      }
    },
  },
  mutations: {
    [ADMIN_SET_AUTH](state, data) {
      const { UserName, Ticket, Type, UserMode } = data;
      state.userName = UserName;
      state.token = Ticket;
      state.type = Type;
      state.userMode = UserMode;
      const login = {
        userName: UserName,
        token: Ticket,
        type: Type,
        userMode: UserMode
      };

      localStorage.setItem("admin", JSON.stringify(login));
    },
    [ADMIN_LOG_OUT](state) {
      state.userName = null;
      state.token = null;
      state.type = null;
      state.userMode = null;
      localStorage.removeItem("admin");
    }
  }
};
